import React from "react";
import { Table, Select, Menu, Dropdown, message, Collapse } from "antd";
import Header from "../../../../layout/Header";
import Sidebar from "../../../../layout/Sidebar";
import moment from "moment";
import copy from "copy-to-clipboard";
import {
  ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS_RADCLIFF,
  ACTIVE_STATUS_LIST,
  NOT_ACTIVE_STATUS_LIST,
  ALL_STATUS_LIST,
  FILTER_BY_ACTIVITY_LIST,
} from "../../../../constants/SelectOptions";
import ViewEalsFrs from "../../../../components/modal/ViewEalsFrs";
import ViewARESScore from "../../../../components/modal/ViewARESScore";
import ViewCpibForm from "../../../../components/modal/ViewCpibForm";
import Bridge from "../../../../constants/Bridge";
import helperfunction from "../../../../constants/functions";
import RadcliffNote from "../../../../components/common/RadcliffNote";
import Strings from "../../../../constants/Strings";
import Synopsis from "./Synopsis";
import $ from 'jquery'

const { Option } = Select;

class List extends React.Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      participants: [],
      loading: false,
      filteredParticipantList: [],
      copyParticipantList: [],
      tableLoading: false,
      selectedStatus: [],
      selectedParticipants: [],
      selectedParticipantsCom: "",
      searchVal: "",
      selectedStatus: [],
      sortBy: "",
      selectedColumns: [],
      activeColumns: [],
      detailsModal: false,
      singleLogDetails: "",
      isStatusModalVisible: false,
      updateStatus: "",
      dropOutInput: "",
      singleParticipant: "",
      dropOutSelected: false,
      singleNoteDetails: "",
      noteModal: false,
      note: "",
      researchBy: "modality.ai",
      researchTypeOptions: [],
      logLoader: false,
      reminderLogData: [],
      toggleReminderModal: false,
      reminderModalLoader: false,
      researchTypes: [],
      reminderParList: [],
      reminderPopup: false,
      reminderType: "",
      copyOfReminderParList: [],
      selectAllStatus: false,
      pagination: 30,
      emailTitle: "",
      emailBody: "",
      formLoading: false,
      selectParticForCustomEmail: [],
      phiStatus: false,
      assignmodal: false,
      assignparticipantid: "",
      assignambassadorlist: [],
      ambassadorlist: [],
      formloader: false,
      filterparticipantdata: [],
      tableloader: false,
      participantType: "",
      copyOfAmbassadorlist: [],
      isSingleColumn: false,
      selectedOnboardingStatus: "",
      type: "active",
      isTypeChanged: false,
      participants_id: 0,
      sessionFrequencyModalStatus: false,
      sessionFrequency: "",
      sessionFrequencyLoader: false,
      selectedSessionType: "",
      totalParticipantCount: 0,
      needtoupgrade: false,
    };
  }
  // get coordinator list
  getambassadorlist = () => {
    this.setState({ tableLoading: true });
    Bridge.ambassadors
      .list()
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            ambassadorlist: response.data,
            tableLoading: false,
            copyOfAmbassadorlist: response.data,
          });
        }
      })
      .catch((error) => {
        this.setState({ tableLoading: false });
      });
  };
  // get participant list
  getParticipantList = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramValue = searchParams.get("filter_status"); // Replace 'paramName' with your parameter name
    this.setState({ tableloader: true, totalParticipantCount: 0 });
    if (this.state.researchBy != "") {
      let type = this.state.type;
      const searchParams = new URLSearchParams(window.location.search);
      const paramValue = searchParams.get("filter_status");
      if (this.state.isTypeChanged == false) {
        if (paramValue === "All") {
          type = "all";
          this.setState({ type: "all" });
        } else if (paramValue === "Withdrawn") {
          type = "not_active";
          this.setState({ type: "not_active" });
        }
      }
      let url = `?research_type=Radcliff Project&type=${type}`;
      Bridge.participants
        .getParticipantList(url)
        .then((response) => {
          if (response.data.status == "1") {
            response.data.data.forEach((item, index) => {
              item.selectBoxStatus = "0";
            });
            let participantResponse = response.data.data;
            setTimeout(() => {
              let participantData = [];
              for (let data of participantResponse) {
                if (data.last_session || data.first_session) {
                  let newArray = data.last_session.split("T");
                  let newArray2 = data.first_session.split("T");
                  data.last_session = moment(newArray[0]).format("MM/DD/YYYY");
                  data.first_session = moment(newArray2[0]).format(
                    "MM/DD/YYYY"
                  );
                }
                if (data.last_contacted != "" && data.last_contacted != null) {
                  let stringreplace = data.last_contacted.split("/");
                  let last_contacted_date =
                    stringreplace[2] +
                    "-" +
                    stringreplace[1] +
                    "-" +
                    stringreplace[0];
                  data.last_contacted =
                    moment(last_contacted_date).format("MM/DD/YYYY");
                }
                participantData = [...participantData, data];
              }
              this.setState(
                {
                  participants: participantData,
                  filteredParticipantList: participantData,
                  copyParticipantList: participantData,
                  totalParticipantCount: participantData.length,
                  searchVal: "",
                },
                () => {
                  this.populateFirstnameFilterData(participantData);
                  this.setState({ tableloader: false });
                }
              );
            }, 1000);
          } else if (response.data.status == "4") {
            let list = [
              {
                participants_id: 0,
                relation_to_als: "",
                referred_by: "",
                date_joined: "",
                session_frequency: "monthly",
                participants_accounts_id: 0,
                neurostamp_id: "NSTYDSSSS03",
                modality_id: "dss23sdssdsdwgghgjhjhjkjddddddd",
                eals_id: "",
                research_type: "Radcliff Project",
                consent_status: "Account Created",
                dropped_out_reason: "",
                dropped_out_date: "",
                dropped_out_person: "",
                dropped_out_other_reason: "",
                radcliff_session_type: "Independent",
                date_started_independant_session: "09/13/2023",
                date_created: "2022-10-06T07:54:12.000Z",
                date_updated: "2023-09-14T09:17:53.000Z",
                date_of_birth: "07/07/2023",
                date_of_dignosis: "07/13/2023",
                last_session: "",
                first_session: "",
                total_sessions: 0,
                als: "",
                controls: "",
                shoe_size: "",
                spirometer_id: "9090",
                right_sole_id: "1234",
                left_sole_id: "1234",
                radcliff_session_entry_count: 0,
                self_report_count: 0,
                self_report_first_session_date: "",
                self_report_last_session_date: "",
                session_entry_first_session_date: "",
                session_entry_last_session_date: null,
                radcliff_date_of_diagnosis: "07/13/2023",
                radclff_ethnicity: "White",
                radcliff_date_of_onset: "07/01/2023",
                radcliff_gender: "Male",
                radcliff_date_of_birth: "07/07/2023",
              },
              {
                participants_id: 1,
                relation_to_als: "",
                referred_by: "",
                date_joined: "",
                session_frequency: "monthly",
                participants_accounts_id: 1,
                neurostamp_id: "NSTYDSSSS01",
                modality_id: "dss23sdsfdfgghgjhjhjkjddddddd",
                eals_id: "",
                research_type: "Radcliff Project",
                consent_status: "Account Created",
                dropped_out_reason: "",
                dropped_out_date: "",
                dropped_out_person: "",
                dropped_out_other_reason: "",
                radcliff_session_type: "Independent",
                date_started_independant_session: "09/13/2023",
                date_created: "2022-10-06T07:54:12.000Z",
                date_updated: "2023-09-14T09:17:53.000Z",
                date_of_birth: "07/07/2023",
                date_of_dignosis: "07/13/2023",
                last_session: "",
                first_session: "",
                total_sessions: 0,
                als: "",
                controls: "",
                shoe_size: "",
                spirometer_id: "9090",
                right_sole_id: "1234",
                left_sole_id: "1234",
                radcliff_session_entry_count: 0,
                self_report_count: 0,
                self_report_first_session_date: "",
                self_report_last_session_date: "",
                session_entry_first_session_date: "",
                session_entry_last_session_date: null,
                radcliff_date_of_diagnosis: "07/13/2023",
                radclff_ethnicity: "White",
                radcliff_date_of_onset: "07/01/2023",
                radcliff_gender: "Male",
                radcliff_date_of_birth: "07/07/2023",
              },
            ];
            this.setState({
              tableloader: false,
              totalParticipantCount: response.data.count,
              participants: list,
              needtoupgrade: true,
            });
          } else {
            this.setState({ tableLoading: false });
          }
        })
        .catch((error) => {
          this.setState({ tableLoading: false });
        });
    }
  };
  // filter column of first name
  populateFirstnameFilterData = (participantData) => {
    const filterparticipantdata = participantData.map((div) => {
      return {
        text: div.participant_name,
        value: div.participant_lname,
      };
    });
    this.setState({ filterparticipantdata });
  };
  // get research type
  getResearchTypeList() {
    this.setState({ tableLoading: true });
    Bridge.participants
      .getResearchTypeList()
      .then((response) => {
        if (response.data.status == "1") {
          this.setState(
            {
              researchTypes: response.data.data,
              tableLoading: false,
            },
            () => this.getParticipantList()
          );
        }
      })
      .catch((error) => {
        this.setState({ tableLoading: false });
      });
  }
  // on load component function
  componentDidMount() {
    if($(window).width() < 600){
      console.log("window::", window);
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
      }else{
        $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
      }
    this.getParticipantList();
    this.getambassadorlist();
    setTimeout(() => {
      this.setState(
        {
          selectedColumns: ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS_RADCLIFF,
        },
        () =>
          this.setTableColumns(
            ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS_RADCLIFF
          )
      );
    }, 400);
  }
  // on change columns
  handleChangeColumns = (value) => {
    this.setState(
      {
        selectedColumns: value,
      },
      () => this.setTableColumns(value)
    );
  };
  // select all input
  onChangeSelectAllInput = (event) => {
    let status = !this.state.selectAllStatus;
    this.setState({ selectAllStatus: status });
    let patientlist = [];
    if (status == true) {
      let participantdata = this.state.participants;
      for (let data of participantdata) {
        data.selectBoxStatus = "1";
        patientlist.push(data);
      }
      this.setState({ participants: patientlist });
    } else if (status == false) {
      let participantdata = this.state.participants;
      for (let data of participantdata) {
        data.selectBoxStatus = "0";
        patientlist.push(data);
      }
      this.setState({ participants: patientlist });
    }
    let inner = [];
    let selected = [];
    let ccopyOfReminderParList = [];
    let selected_participants = [];
    for (let data of patientlist) {
      if (data.selectBoxStatus == "1") {
        selected_participants.push(data);
        inner = [...inner, data.modality_id];
        if (data.consent_status != "Dropped Out") {
          selected = [...selected, data.participants_accounts_id];
        }
        ccopyOfReminderParList = [
          ...ccopyOfReminderParList,
          data.participants_accounts_id,
        ];
      }
    }
    this.setState({
      selectedParticipants: inner,
      selectedParticipantsCom: selected_participants,
      selectedParticipantToSend: selected,
      reminderParList: selected,
      copyOfReminderParList: ccopyOfReminderParList,
    });
  };
  // on change radcliff form status
  change_radcliff_form_status = (param, item) => {
    let params = {
      participants_accounts_id: item.participants_accounts_id,
      status: param.target.value,
      fname: item.participant_name,
      lname: item.participant_lname,
      eals_id: item.eals_id,
      email: item.participant_email,
      phone: item.participant_phone,
    };
    Bridge.participants.update_radcliff_form_status(params).then((response) => {
      if (response.status == "1") {
        message.success(response.message);
        this.getParticipantList();
      }
    });
  };
  // set table columns
  setTableColumns = (options) => {
    let columnsArr = [];
    columnsArr = [...columnsArr];
    let i = 0;
    for (let columnOption of options) {
      let obj = {};
      if (columnOption == "Neurostamp Id") {
        obj = {
          title: "Neurostamp Id",
          dataIndex: "neurostampId",
          key: "neurostampId",
          width: 170,
          columOrder: 1,
          fixed: window.innerWidth > 650 ? "left" : false,
          render: (item) => {
            let iconText = "";
            if (item.relation_to_als == "Living with ALS") {
              iconText = "ALS";
            } else if (item.relation_to_als == "Asymptomatic Gene Carrier") {
              iconText = "GC";
            } else if (
              item.relation_to_als == "Caregiver" ||
              item.relation_to_als == "Family Member" ||
              item.relation_to_als == "Friend" ||
              item.relation_to_als == "Healthcare professional" ||
              item.relation_to_als == "Other"
            ) {
              iconText = "C";
            } else {
              iconText = "";
            }
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data d-flex">
                  {item.neurostamp_id ? item.neurostamp_id : "---"}
                  {iconText && (
                    <div className="participant-icon ml-0">{iconText}</div>
                  )}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "First Session Date") {
        obj = {
          title: "First Session Date",
          dataIndex: "first_session_date",
          key: "first_session_date",
          columOrder: 2,
          width: 180,
          render: (item) => {
            let self_first_date = item.self_report_first_session_date;
            let session_entry_first_date =
              item.session_entry_first_session_date;
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  <span style={{ fontWeight: "500" }}>Proctored:</span>{" "}
                  {session_entry_first_date ? session_entry_first_date : "---"}
                  <br />
                  <span style={{ fontWeight: "500" }}>Self:</span>{" "}
                  {self_first_date ? self_first_date : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Last Session Date") {
        obj = {
          title: "Last Session Date",
          dataIndex: "last_session_date",
          key: "last_session_date",
          columOrder: 3,
          width: 180,
          render: (item) => {
            let self_report_date = item.self_report_last_session_date;
            let session_entry_date = item.session_entry_last_session_date;
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  <span style={{ fontWeight: "500" }}>Proctored:</span>{" "}
                  {session_entry_date ? session_entry_date : "---"}
                  <br />
                  <span style={{ fontWeight: "500" }}>Self:</span>{" "}
                  {self_report_date ? self_report_date : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // no of sessions = 13
      if (columnOption == "No of sessions") {
        obj = {
          title: "No of sessions",
          dataIndex: "no_of_sessions",
          key: "no_of_sessions",
          columOrder: 4,
          width: 120,
          render: (item) => {
            let totalSessions =
              Number(item.self_report_count) +
              Number(item.radcliff_session_entry_count);
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {totalSessions ? totalSessions : "0"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Date Joined") {
        obj = {
          title: "Date Joined",
          dataIndex: "dateJoined",
          key: "dateJoined",
          width: 130,
          columOrder: 5,
          render: (item) => {
            return (
              <div>
                <div
                  className={
                    item.selectBoxStatus && item.selectBoxStatus == "1"
                      ? "grey-div"
                      : ""
                  }
                ></div>
                <div className="table-data">
                  {item.date_joined ? item.date_joined : "---"}
                </div>
              </div>
            );
          },
          multiple: 3,
        };
        columnsArr = [...columnsArr, obj];
      }
      // Shoe Size = 14
      if (columnOption == "Shoe Size") {
        obj = {
          title: "Shoe Size",
          dataIndex: "shoesize",
          key: "shoesize",
          columOrder: 6,
          width: 120,
          render: (item) => {
            let shoe_size = item.shoe_size;
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {shoe_size ? shoe_size : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // Relation To ALS
      if (columnOption == "Relation To ALS") {
        obj = {
          title: "Relation To ALS",
          dataIndex: "relation_to_als",
          key: "relation_to_als",
          width: 150,
          columOrder: 7,
          render: (item) => {
            return (
              <div>
                <div
                  className={
                    item.selectBoxStatus && item.selectBoxStatus == "1"
                      ? "grey-div"
                      : ""
                  }
                ></div>
                <div className="table-data">
                  {item.relation_to_als ? item.relation_to_als : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // session frequency
      if (columnOption == "Session Frequecy") {
        obj = {
          title: "Session Frequecy",
          dataIndex: "session_frequency",
          key: "session_frequency",
          width: 150,
          columOrder: 8,
          render: (item) => {
            return (
              <div>
                <div
                  className={
                    item.selectBoxStatus && item.selectBoxStatus == "1"
                      ? "grey-div"
                      : ""
                  }
                ></div>
                <div
                  className="table-data"
                  style={{ textTransform: "capitalize" }}
                >
                  {item.session_frequency ? item.session_frequency : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // session frequency
      if (columnOption == "Independant/Coach") {
        obj = {
          title: "Independent/Coach",
          dataIndex: "session_type",
          key: "session_type",
          width: 180,
          columOrder: 9,
          render: (item) => {
            return (
              <div>
                <div></div>
                <div
                  className="table-data"
                  style={{ textTransform: "capitalize" }}
                >
                  {item.radcliff_session_type
                    ? item.radcliff_session_type
                    : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // gender
      if (columnOption == "Gender") {
        obj = {
          title: "Gender",
          dataIndex: "gender",
          key: "gender",
          width: 150,
          columOrder: 10,
          render: (item) => {
            return (
              <div>
                <div></div>
                <div
                  className="table-data"
                  style={{ textTransform: "capitalize" }}
                >
                  {item.radcliff_gender ? item.radcliff_gender : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      // address = 11
      if (columnOption == "Date of Diagnosis") {
        obj = {
          title: "Date of Diagnosis",
          dataIndex: "dateofdignosis",
          key: "dateofdignosis",
          width: 150,
          columOrder: 11,
          render: (item) => {
            return (
              <div>
                <div
                  className={item.selectBoxStatus == "1" ? "grey-div" : ""}
                ></div>
                <div className="table-data">
                  {item.radcliff_date_of_diagnosis
                    ? item.radcliff_date_of_diagnosis
                    : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Date of Onset") {
        obj = {
          title: "Date of Onset",
          dataIndex: "date_of_onset",
          key: "date_of_onset",
          width: 150,
          columOrder: 12,
          render: (item) => {
            return (
              <div>
                <div></div>
                <div
                  className="table-data"
                  style={{ textTransform: "capitalize" }}
                >
                  {item.radcliff_date_of_onset
                    ? moment(item.radcliff_date_of_onset).format("MM/DD/YYYY")
                    : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Age") {
        obj = {
          title: "Age",
          dataIndex: "age",
          key: "age",
          width: 150,
          columOrder: 13,
          render: (item) => {
            let age = "";
            if (item.radcliff_date_of_birth) {
              let date_of_birth = moment(item.radcliff_date_of_birth).format(
                "YYYY-MM-DD"
              );
              let calculateAge = this.calculateAge(date_of_birth);
              age = calculateAge;
            }
            return (
              <div>
                <div></div>
                <div
                  className="table-data"
                  style={{ textTransform: "capitalize" }}
                >
                  {age ? age : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Ethincity") {
        obj = {
          title: "Ethincity",
          dataIndex: "ethincity",
          key: "ethincity",
          width: 150,
          columOrder: 14,
          render: (item) => {
            return (
              <div>
                <div></div>
                <div
                  className="table-data"
                  style={{ textTransform: "capitalize" }}
                >
                  {item.radclff_ethnicity ? item.radclff_ethnicity : "---"}
                </div>
              </div>
            );
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      if (columnOption == "Status") {
        obj = {
          title: "Status",
          dataIndex: "status",
          key: "status",
          width: 120,
          columOrder: 15,
          fixed: window.innerWidth > 650 ? "right" : false,
          render: (item) => {
            let data = "";
            if (item.consent_status != "" && item.consent_status == "Signed") {
              data = (
                <td
                  className="status-div"
                  style={{ backgroundColor: "#b6d7a8" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (
              item.consent_status != "" &&
              item.consent_status == "E consent sent"
            ) {
              data = (
                <td className="status-div" style={{ background: "#ffe599" }}>
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (
              item.consent_status != "" &&
              item.consent_status == "Dropped Out"
            ) {
              data = (
                <td
                  className="status-div text-white"
                  style={{ background: "#ff0000" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (
              item.consent_status != "" &&
              item.consent_status == "Study Completed"
            ) {
              data = (
                <td
                  className="status-div"
                  style={{ background: "rgb(194 166 247)" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "New") {
              data = (
                <td
                  className="status-div text-white"
                  style={{ background: "#8863dd" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "Account Created") {
              data = (
                <td
                  className="status-div text-white"
                  style={{ background: "#01a3b7" }}
                >
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "Cancel") {
              data = (
                <td className="status-div text-white cancel-color">
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "Active") {
              data = (
                <td className="status-div text-white active-status-color">
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            } else if (item.consent_status == "") {
              data = (
                <td className="status-div" style={{ background: "#fff" }}>
                  {item.consent_status ? item.consent_status : "---"}
                </td>
              );
            }
            return <div style={{ width: "100%" }}>{data}</div>;
          },
        };
        columnsArr = [...columnsArr, obj];
      }
      i++;
    }
    let actionobj = {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 85,
      columOrder: 16,
      fixed: window.innerWidth > 650 ? "right" : false,
      render: (item) => {
        const menu = (
          <Menu className="action-menu participant-action-menu">
            {/* <Menu.Item key={`view_demographics${item.key}`}>
              <a
                className="action-buttons"
                href={`/participant/view-demographics?neurostamp_id=${item.neurostamp_id}`}
              >
                <i
                  className="fab fa-wpforms"
                  style={{ color: "#000", fontSize: 18 }}
                ></i>
                <span style={{ fontSize: 14, marginLeft: 10 }}>
                  View Demographics
                </span>
              </a>
            </Menu.Item> */}
            <Menu.Item key={`view_eals_frs${item.key}`}>
              <ViewEalsFrs
                item={item}
                action={() => this.reloadParticipants()}
              />
            </Menu.Item>
            <Menu.Item key={`view_ares_score${item.key}`}>
              <ViewARESScore item={item} />
            </Menu.Item>
            <Menu.Item key={`view_cpib_form_list${item.key}`}>
              <ViewCpibForm item={item} />
            </Menu.Item>
          </Menu>
        );
        return (
          <div style={{ width: "100%" }}>
            <Dropdown overlay={menu}>
              <a
                className="ant-dropdown-link action-link"
                onClick={(e) => e.preventDefault()}
              >
                <i className="fas fa-ellipsis-v"></i>
              </a>
            </Dropdown>
          </div>
        );
      },
    };
    columnsArr = [...columnsArr, actionobj];
    columnsArr.sort((a, b) => {
      return a.columOrder - b.columOrder;
    });
    this.setState({ activeColumns: columnsArr });
  };
  // Open Session Frequency modal
  openSessionFrequencyModal = (item) => {
    this.setState({
      sessionFrequencyModalStatus: true,
      participants_id: item.participants_id,
      sessionFrequency: item.session_frequency,
    });
  };
  // shop profile details
  show_profile_details = (params) => {
    params = JSON.stringify(params);
    localStorage.setItem("profile_details", params);
    window.location.assign("/profile-details");
  };
  // copy data
  copydata = (text) => {
    copy(text, {
      debug: true,
      message: "Link is copied",
    });
    message.success("Copied to clipboard.");
  };
  // show zephyrx data
  show_zephyrx_data = (item) => {
    let eals_id = item.eals_id;
    let name = item.participant_name + " " + item.participant_lname;
    localStorage.setItem("eals_id", eals_id);
    localStorage.setItem("participant_name", name);
    window.location.assign("/participant/zephyrx-data");
  };
  // show aural data
  show_aural_data = (item) => {
    let eals_id = item.eals_id;
    let name = item.participant_name + " " + item.participant_lname;
    localStorage.setItem("peals_id", eals_id);
    localStorage.setItem("participant_name", name);
    window.location.assign("/participants/aural");
  };
  // reload particiapnts
  reloadParticipants = () => {
    this.getParticipantList();
  };
  // show assign modal
  showassignammodal = (item) => {
    let assignedto = "";
    let arr = [];
    if (item.assigned_to) {
      let text = item.assigned_to;
      const myArray = text.split(",");
      for (let d of this.state.ambassadorlist) {
        if (myArray.includes(d.student_name)) {
          arr = [...arr, d.students_id];
        }
      }
    }
    this.setState({
      assignmodal: true,
      assignparticipantid: item.participants_id,
      assignambassadorlist: arr,
    });
  };
  calculateAge = (birthday) => {
    const today = new Date();
    const birthDate = new Date(birthday);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };
  // hide assig modal
  hideassignmodal = () => {
    this.setState({
      assignmodal: false,
    });
  };
  // on select ambassadors
  handleSelectAm = (value) => {
    this.setState({ assignambassadorlist: value });
  };
  // assign coordiantors
  assignambassor = () => {
    if (this.state.assignambassadorlist.lenth == 0) {
      message.warning("Please select the Coordinator first.");
      return;
    }
    let params = {
      participants_id: this.state.assignparticipantid,
      students: JSON.stringify(this.state.assignambassadorlist),
    };
    this.setState({ formloader: true });
    Bridge.ambassadors
      .assignambassador(params)
      .then((response) => {
        if (response.status == "1") {
          message.success(response.message);
          this.setState(
            {
              assignmodal: false,
              participants_id: "",
              students: [],
              formloader: false,
            },
            () => this.getParticipantList()
          );
        }
      })
      .catch((error) => {});
  };
  // OPEN PATIENT PORTAL
  openParticipantPortal = (item) => {
    if (!item.eals_id) {
      message.warning("No url is found");
      return;
    }
    let url = `?eals_id=${item.eals_id}`;
    Bridge.participants
      .open_radcliff_participants_portal(url)
      .then((result) => {
        if (result.status == "1") {
          window.open(result.data, "_blank");
        } else {
          message.warn(result.message);
        }
      })
      .catch(function (error) {
        message.error("Please try again!!");
      });
  };
  // open custom email mdoal
  openCustomEmailModal = (item) => {
    this.setState({
      customModalStatus: true,
      formLoading: false,
      selectedParticipantToSend: item.participants_accounts_id,
      emailTitle: "",
      emailBody: "",
    });
  };
  // show remidner popup
  handleShowReminderPopup = (item) => {
    let arr = [item.participants_accounts_id];
    this.setState({
      reminderParList: arr,
      reminderPopup: true,
      reminderType: "1",
    });
  };
  // hide remidner mdoal
  handleCancelReminder = () => {
    this.setState({
      reminderPopup: false,
    });
  };
  // on ok remidner modal
  handleOkReminder = () => {
    this.setState(
      {
        reminderPopup: false,
      },
      () => this.sendNotificationToParti()
    );
  };
  // send nifiction to participant
  sendNotificationToParti = () => {
    let params = {
      participants_array: JSON.stringify(this.state.reminderParList),
      time_sent:
        new Intl.DateTimeFormat("en-US", {
          dateStyle: "full",
          timeStyle: "long",
        }).format(new Date()) +
        " " +
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    if (this.state.reminderParList.length == "0") {
      message.warning("Please select valid participant(s) first.");
      this.setState({ tableLoading: false });
      return;
    }
    this.setState({ tableLoading: true });
    Bridge.participants
      .sendReminder(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({ tableLoading: false });
        } else {
          message.warning(response.data.message);
          this.setState({ tableLoading: false });
        }
      })
      .catch(function (error) {
        this.setState({ tableLoading: false });
      });
  };
  // fitler by status
  filterStatus = (value) => {
    this.setState(
      {
        selectedStatus: value,
      },
      () => this.filter_data()
    );
  };
  // on change sort by
  handleSortChange = (value) => {
    this.setState(
      {
        sortBy: value,
      },
      () => this.filter_data()
    );
  };
  // on change date format
  changeDateFormat = (arr) => {
    let newArr = [];
    for (let data of arr) {
      if (data.last_contacted != null) {
        let string = data.last_contacted;
        let search = "-";
        let replaceWith = "/";
        let result = string
          .split(search)
          .reverse()
          .join(replaceWith)
          .toString();
        data.last_contacted = result;
      }
      newArr.push(data);
    }
    return newArr;
  };
  // show details modal
  showDetailsModal = (item) => {
    this.setState({ detailsModal: true });
    this.getNotesForParticipant(item);
  };
  // hide details modal
  hideDetailsModal = () => {
    this.setState({ detailsModal: false });
  };
  // on status ok
  handleStatusOk = () => {
    this.setState({
      isStatusModalVisible: false,
      updateStatus: "",
    });
    this.pleaseUpdateStatus();
  };
  // hide status modal
  handleStatusCancel = () => {
    this.setState({
      isStatusModalVisible: false,
      updateStatus: "",
    });
  };
  // opn change status
  handleChange = (value) => {
    this.setState({ updateStatus: value });
    if (value == "Dropped Out") {
      this.setState({ dropOutSelected: true });
    } else {
      this.setState({ dropOutSelected: false });
    }
  };
  // on change dropout option
  handleChangeDropOut = (value) => {
    this.setState({ dropOutInput: value });
  };
  // show status modal
  showStatusModal = (item) => {
    this.setState({
      isStatusModalVisible: true,
      updateStatus: item.consent_status,
      singleParticipant: item,
    });
  };
  // update status
  pleaseUpdateStatus = () => {
    let params = {
      consent_status: this.state.updateStatus,
      participants_id: this.state.singleParticipant.participants_id,
    };
    Bridge.participants
      .updateStatus(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
        } else {
          message.error(response.data.message);
        }
        this.getParticipantList();
      })
      .catch(function (error) {
        message.error("Please try again!!");
      });
  };
  // on change reseach type
  handleChangeResearchType = (value) => {
    this.setState({ researchBy: value }, () => this.getParticipantList());
  };
  // show reports of selected reports
  view_report = () => {
    console.log("selectedParticipantsCom", this.state.selectedParticipantsCom);
    if (this.state.selectedParticipantsCom.length == "0") {
      message.warn("Please select participant(s) first.");
      return;
    }
    let data = this.state.selectedParticipantsCom;
    this.props.history.push({
      pathname: `/radcliff-participant/view-report`,
      state: { data: data },
    });
  };
  // hide reminder modal
  handleCancelReminderModal = () => {
    this.setState({ toggleReminderModal: false });
  };
  // open modal to send notification
  openModalToSendNot = () => {
    this.setState({
      reminderPopup: true,
    });
  };
  // on change table pagination
  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      pagination: pagination.pageSize,
    });
  };
  // close custom email modal
  closeCustomEmailModal = () => {
    this.setState({
      customModalStatus: false,
    });
  };
  // on change participant type
  handleChangeParticipantType = (value) => {
    this.setState({ participantType: value });
    let arr = [];
    if (value == "controls") {
      for (let item of this.state.copyParticipantList) {
        if (item.controls) {
          arr = [...arr, item];
        }
      }
    } else if (value == "als") {
      for (let item of this.state.copyParticipantList) {
        if (item.als) {
          arr = [...arr, item];
        }
      }
    } else if (value == "all") {
      for (let item of this.state.copyParticipantList) {
        arr = [...arr, item];
      }
    }
    let arr2 = [];
    // if search text is present
    if (this.state.searchVal.length > 0 && arr.length > 0) {
      let SearchVal = this.state.searchVal;
      for (let item of arr) {
        if (
          (item.participant_name &&
            item.participant_name
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.participant_lname &&
            item.participant_lname
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.participant_email &&
            item.participant_email
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.participant_phone &&
            item.participant_phone
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.referred_by &&
            item.referred_by.toLowerCase().includes(SearchVal.toLowerCase())) ||
          (item.neurostamp_id &&
            item.neurostamp_id
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.research_type &&
            item.research_type
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.research_type &&
            item.research_type
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.relation_to_als &&
            item.relation_to_als
              .toLowerCase()
              .includes(SearchVal.toLowerCase())) ||
          (item.consent_status &&
            item.consent_status.toLowerCase().includes(SearchVal.toLowerCase()))
        ) {
          arr2 = [...arr2, item];
        }
      }
    } else {
      arr2 = arr;
    }
    let arr3 = [];
    if (arr2.length > 0 && this.state.selectedStatus.length > 0) {
      for (let item of arr2) {
        if (this.state.selectedStatus.includes(item.consent_status)) {
          arr3 = [...arr3, item];
        }
      }
    } else {
      arr3 = arr2;
    }
    this.setState({ participants: arr3 });
  };
  // on search
  onSearch = (value) => {};
  // safely parse date string to milliseconds for sorting
  parseDateToMs = (dateString, missingAsHigh = false) => {
    if (!dateString || typeof dateString !== "string") {
      return missingAsHigh ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    }
    const m = moment(
      dateString,
      [
        "MM/DD/YYYY",
        "YYYY-MM-DD",
        "YYYY/MM/DD",
        "DD/MM/YYYY",
        "DD-MM-YYYY",
        "YYYY-DD-MM",
      ],
      true
    );
    if (m.isValid()) {
      return m.valueOf();
    }
    // Fallback: try native Date as a last resort
    const n = new Date(dateString).getTime();
    if (!isNaN(n)) {
      return n;
    }
    return missingAsHigh ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
  };
  // robust comparators that keep finite values ahead of missing
  compareMsAsc = (aMs, bMs) => {
    const aFinite = Number.isFinite(aMs);
    const bFinite = Number.isFinite(bMs);
    if (aFinite && bFinite) return aMs - bMs;
    if (aFinite && !bFinite) return -1;
    if (!aFinite && bFinite) return 1;
    return 0;
  };
  compareMsDesc = (aMs, bMs) => {
    const aFinite = Number.isFinite(aMs);
    const bFinite = Number.isFinite(bMs);
    if (aFinite && bFinite) return bMs - aMs;
    if (aFinite && !bFinite) return -1;
    if (!aFinite && bFinite) return 1;
    return 0;
  };
  // get comparable last-session ms using available fields
  // Uses the most recent among available dates (proctored/self/fallbacks)
  // Ignores missing values; returns +Infinity only if all are missing
  getLastSessionMs = (record) => {
    const candidates = [];
    const pushIfFinite = (ms) => {
      if (Number.isFinite(ms)) candidates.push(ms);
    };
    // Parse without forcing missing to +/-Infinity; we will filter non-finite
    pushIfFinite(this.parseDateToMs(record && record.session_entry_last_session_date, false));
    pushIfFinite(this.parseDateToMs(record && record.self_report_last_session_date, false));
    // Fallbacks commonly present in payload
    pushIfFinite(this.parseDateToMs(record && record.radcliff_last_session_date, false));
    pushIfFinite(this.parseDateToMs(record && record.last_session, false));
    if (candidates.length > 0) {
      return Math.max(...candidates);
    }
    return Number.POSITIVE_INFINITY; // push blanks to bottom
  };
  // get comparable last-contacted ms (supports multiple API field names)
  // Considers: last_contact_date (API), last_contacted_date, last_contacted
  // Returns the most recent among available; respects missingAsHigh for blanks
  getLastContactedMs = (record, missingAsHigh = false) => {
    const candidates = [];
    const pushIfFinite = (dateStr) => {
      const ms = this.parseDateToMs(dateStr, missingAsHigh);
      if (Number.isFinite(ms)) candidates.push(ms);
    };
    pushIfFinite(record && record.last_contact_date);
    pushIfFinite(record && record.last_contacted_date);
    pushIfFinite(record && record.last_contacted);
    if (candidates.length > 0) {
      return Math.max(...candidates);
    }
    return missingAsHigh ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
  };
  // get proctored last session date only (push missing to bottom)
  getProctoredSessionMs = (record) => {
    return this.parseDateToMs(
      record && record.session_entry_last_session_date,
      true // missingAsHigh: always push missing to bottom
    );
  };
  filter_data = () => {
    let searchArray = [];
    let searchInput = this.state.searchVal;
    if (searchInput) {
      for (let d of this.state.copyParticipantList) {
        let date_of_birth = d.date_of_birth
          ? moment(d.date_of_birth).format("MM/DD/YYYY")
          : "";
        let date_of_diagnosis = d.radcliff_date_of_diagnosis
          ? moment(d.radcliff_date_of_diagnosis).format("MM/DD/YYYY")
          : "";
        let first_session = d.radcliff_first_session_date
          ? moment(d.radcliff_first_session_date).format("MM/DD/YYYY")
          : "";

        let last_session = d.radcliff_last_session_date
          ? moment(d.radcliff_last_session_date).format("MM/DD/YYYY")
          : "";

        let walking_devices = d.walking_devices
          ? JSON.parse(d.walking_devices)
          : "";
        let breathing_devices = d.breathing_devices
          ? JSON.parse(d.breathing_devices)
          : "";
        walking_devices =
          walking_devices.length > 0
            ? walking_devices.join(",").toLowerCase()
            : "";

        breathing_devices =
          breathing_devices.length > 0
            ? breathing_devices.join(",").toLowerCase()
            : "";

        let phone_no = helperfunction.changePhoneNoFormat(d.participant_phone);

        if (
          (walking_devices &&
            walking_devices.includes(searchInput.toLowerCase())) ||
          (breathing_devices &&
            breathing_devices.includes(searchInput.toLowerCase())) ||
          (date_of_birth &&
            date_of_birth.toLowerCase().includes(searchInput.toLowerCase())) ||
          (date_of_diagnosis &&
            date_of_diagnosis
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (first_session &&
            first_session.toLowerCase().includes(searchInput.toLowerCase())) ||
          (last_session &&
            last_session.toLowerCase().includes(searchInput.toLowerCase())) ||
          (d.shoe_size && d.shoe_size == searchInput.toLowerCase()) ||
          (d.eals_id &&
            d.eals_id.toLowerCase().includes(searchInput.toLowerCase())) ||
          (d.neurostamp_id &&
            d.neurostamp_id
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.research_type &&
            d.research_type
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.relation_to_als &&
            d.relation_to_als
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.consent_status &&
            d.consent_status
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.first_session &&
            d.first_session.includes(searchInput.toLowerCase())) ||
          (d.last_session &&
            d.last_session.includes(searchInput.toLowerCase())) ||
          (d.last_contacted &&
            d.last_contacted.includes(searchInput.toLowerCase())) ||
          (d.date_joined &&
            d.date_joined.includes(searchInput.toLowerCase())) ||
          (d.modality_id &&
            d.modality_id.toLowerCase().includes(searchInput.toLowerCase())) ||
          (d.last_contacted_name &&
            d.last_contacted_name
              .toLowerCase()
              .includes(searchInput.toLowerCase())) ||
          (d.assigned_to &&
            d.assigned_to.toLowerCase().includes(searchInput.toLowerCase()))
        ) {
          searchArray.push(d);
        }
      }
    } else {
      searchArray = this.state.copyParticipantList;
    }
    //filter by status
    let statusArray = [];
    if (this.state.selectedStatus.length > 0) {
      for (let item of searchArray) {
        if (this.state.selectedStatus.includes(item.consent_status)) {
          statusArray.push(item);
        }
      }
    } else {
      statusArray = searchArray;
    }
    // apply Sort By selection (dropdown-driven)
    let baseArray = statusArray;
    if (this.state.sortBy) {
      const arrayToSort = [...statusArray];
      if (this.state.sortBy === "LastContactedAsc") {
        baseArray = arrayToSort.sort((a, b) =>
          this.compareMsAsc(
            this.getLastContactedMs(a, true),
            this.getLastContactedMs(b, true)
          )
        );
      } else if (this.state.sortBy === "LastContactedDesc") {
        baseArray = arrayToSort.sort((a, b) =>
          this.compareMsDesc(
            this.getLastContactedMs(a, true),
            this.getLastContactedMs(b, true)
          )
        );
      } else if (this.state.sortBy === "LastActiveAsc") {
        baseArray = arrayToSort.sort((a, b) =>
          this.compareMsAsc(
            this.getLastSessionMs(a),
            this.getLastSessionMs(b)
          )
        );
      } else if (this.state.sortBy === "LastActiveDesc") {
        baseArray = arrayToSort.sort((a, b) =>
          this.compareMsDesc(
            this.getLastSessionMs(a),
            this.getLastSessionMs(b)
          )
        );
      }
    }

    // debug: log top 5 sort keys and relevant fields
    try {
      const toMs = (rec) => {
        if (
          this.state.sortBy === "LastContactedAsc" ||
          this.state.sortBy === "LastContactedDesc"
        ) {
          return this.getLastContactedMs(rec, true);
        }
        if (
          this.state.sortBy === "LastActiveAsc" ||
          this.state.sortBy === "LastActiveDesc"
        ) {
          return this.getLastSessionMs(rec);
        }
        return 0;
      };
      const topFive = (baseArray || []).slice(0, 5).map((r) => ({
        id: r.neurostamp_id || r.participants_id || r.eals_id || null,
        last_contacted: r.last_contacted || r.last_contacted_date || null,
        session_entry_last_session_date: r.session_entry_last_session_date || null,
        self_report_last_session_date: r.self_report_last_session_date || null,
        sort_ms: toMs(r),
      }));
      console.log("[Sort Debug] sortBy=", this.state.sortBy, topFive);
    } catch (e) {}

    // onboarding filter after sorting
    let onboardingArr = [];
    if (this.state.selectedOnboardingStatus) {
      let onboarding_text = this.state.selectedOnboardingStatus;
      onboardingArr = baseArray.filter(
        (item) => item.radcliff_form_status == onboarding_text
      );
    } else {
      onboardingArr = baseArray;
    }
    // session type filter (Independent/Coach)
    let sessionTypeArray = onboardingArr;
    if (this.state.selectedSessionType) {
      const type = this.state.selectedSessionType;
      sessionTypeArray = onboardingArr.filter(
        (item) => item.radcliff_session_type == type
      );
    }
    this.setState({
      participants: sessionTypeArray,
      totalParticipantCount: sessionTypeArray.length,
    });
  };
  // on change participant type
  handleChangeType = (value) => {
    this.setState(
      {
        type: value,
        selectedStatus: [],
        searchVal: "",
        sortBy: "",
        selectedOnboardingStatus: "",
        isTypeChanged: true,
      },
      () => this.getParticipantList()
    );
  };
  // update session frequency
  updateSessionFrequency = () => {
    let params = {
      participants_id: this.state.participants_id,
      sessionFrequency: this.state.sessionFrequency,
    };
    this.setState({ sessionFrequencyLoader: true });
    Bridge.update_session_frequency(params)
      .then((res) => {
        if (res.status == "1") {
          message.success(res.message);
          this.setState(
            {
              participants_id: 0,
              sessionFrequencyModalStatus: false,
            },
            () => this.getParticipantList()
          );
        } else {
          message.warning(res.message);
        }
        this.setState({ sessionFrequencyLoader: false });
      })
      .catch((err) => {
        message.warning("Something went wrong. Please try again.");
        this.setState({ sessionFrequencyLoader: false });
      });
  };
  // close session frequency modal
  handleCloseSessionFrequencyModal = () => {
    this.setState({
      sessionFrequencyModalStatus: false,
      participants_id: 0,
    });
  };
  onChangeTab = (key) => {
    // console.log(key);
  };
  render() {
    const items = [
      {
        key: "1",
        label: "Synopsis",
        children: (
          <div className="accordion-content">
            <p>
              <Synopsis />
            </p>
          </div>
        ),
      },
    ];
    const dataSource =
      this.state.participants &&
      this.state.participants.map((item, index) => {
        return {
          key: index,
          checkbox: item,
          participantName: item,
          gender: item,
          date_of_diagnosis: item,
          date_of_onset: item,
          age: item,
          ethincity: item,
          email: item,
          phone: item,
          status: item,
          lastContacted: item,
          firstSessionDate: item,
          lastSessionDate: item,
          action: item,
          ambaserder_name: item,
          lastContactedBy: item,
          modalityId: item,
          referredBy: item,
          researchType: item,
          lastName: item,
          lastName: item,
          dateJoined: item,
          neurostampId: item,
          address: item,
          eals_id: item,
          dateofdignosis: item,
          dob: item,
          shoesize: item,
          gaitassistivedevices: item,
          brethingassistivedevices: item,
          relation_to_als: item,
          onboardingStatus: item,
          first_session_date: item,
          last_session_date: item,
          no_of_sessions: item,
          session_frequency: item,
          session_type: item,
        };
      });
    return (
      <div
        className="participant-activity-div radcliff-participant-page"
        style={{ background: "#f5f5f5" }}
      >
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-lg-10 participant-right-section-wrapper">
            <div className="inner-wrapper">
              <div className="row top-space">
                <div className="col-lg-1"></div>
                <div className="col-lg-11">
                  <div className="ambassador-heading-section mb-3">
                    <h3
                      style={{
                        position: "relative",
                        fontSize: 28,
                        fontFamily: "Open Sans",
                        fontWeight: "bold",
                        color: "#1A4F83",
                        textAlign: "start",
                      }}
                      className="mb-3"
                    >
                      {Strings.radcliffParticipants} - (
                      {this.state.type == "all" && "Total Participants"}
                      {/* Hotfix 10/08/2026: label "Active" → "Study Completed" (value still "active") */}
                      {this.state.type == "active" &&
                        "Study Completed Participants"}
                      {this.state.type == "not_active" &&
                        "Withdrawn Participants"}
                      : {this.state.totalParticipantCount})
                    </h3>
                  </div>
                  <div className="synopsis-accordion">
                    <div className="row" style={{ padding: "2%" }}>
                      <Collapse
                        items={items}
                        defaultActiveKey={[]}
                        onChange={this.onChangeTab}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="all-participant-list">
                {/* background overlay  */}
                {this.state.needtoupgrade == true && (
                  <div className="background-overlay">
                    <div className="row">
                      <div className="col-lg-1"></div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11">
                        <div className="need-to-upgrade-wrapper">
                          <div className="inner-ui">
                            {/* <center>
                            <box-icon
                              name="smile"
                              size={"120px"}
                              color="#a6a6a6"
                            ></box-icon>
                          </center> */}
                            <h4>Upgrade to Platinum to access all data</h4>
                            <p>
                              Contact Christian Rubio{" "}
                              <a
                                style={{ color: "#007dfc" }}
                                href="mailto:christian@everythingals.org"
                              >
                                christian@everythingals.org
                              </a>{" "}
                              to learn more about Platinum membership and how to
                              upgrade
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="content">
                  <div className="row mb-3 align-items-center mb-3">
                    <div className="col-lg-1"></div>
                    <div className="col-lg-3 filter-by-activity-input-wrapper">
                      <div>
                        <label>Filter By Activity</label>
                        <Select
                          defaultValue={this.state.type}
                          onChange={this.handleChangeType}
                          value={this.state.type}
                          className="filter-element researchby-input filter-select-menu no-tag-select"
                          placeholder="Select Type"
                          style={{ fontSize: 16 }}
                        >
                          {FILTER_BY_ACTIVITY_LIST.map((item, i) => {
                            return (
                              <Option value={item.value}>
                                {/* Hotfix 10/08/2026: label "Active" → "Study Completed" (value still "active") */}
                                {item.value === "active"
                                  ? "Study Completed"
                                  : item.label}
                              </Option>
                            );
                          })}
                        </Select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-lg-3 filter-by-independant-coach-input">
                      <label>Independent/Coach</label>
                      <Select
                        defaultValue={this.state.selectedSessionType}
                        style={{ width: "100%", fontSize: 16 }}
                        onChange={(value) => {
                          this.setState(
                            {
                              selectedSessionType: value,
                            },
                            () => this.filter_data()
                          );
                        }}
                        value={this.state.selectedSessionType}
                        className="filter-element mb-3 filter-select-menu no-tag-select"
                        placeholder="Session Type"
                      >
                        <Option value="">Select Type</Option>
                        <Option value={"Independent"}>Independent</Option>
                        <Option value={"Coach"}>Coach</Option>
                      </Select>
                    </div>
                    <div className="col-12 col-sm-12 col-lg-4 filter-by-column-input-wrapper">
                      <label>Filter By Column</label>
                      <Select
                        className="select-status participant-ac-column-filter-input"
                        mode="multiple"
                        style={{ width: "95%" }}
                        onChange={this.handleChangeColumns}
                        value={this.state.selectedColumns}
                        placeholder="Filter By Columns"
                        maxTagCount={1}
                      >
                        {ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS_RADCLIFF &&
                          ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS_RADCLIFF.map(
                            (item, index) => {
                              return (
                                <Option key={index} value={item}>
                                  {item}
                                </Option>
                              );
                            }
                          )}
                      </Select>
                    </div>
                  </div>
                  <div className="row participant-activity-row">
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3 search-filter-wrapper">
                      <label>Search</label>
                      <input
                        type="text"
                        className="form-control input-field filter-element mb-3"
                        value={this.state.searchVal}
                        placeholder="Search.."
                        onChange={(e) => {
                          this.setState(
                            {
                              searchVal: e.target.value,
                            },
                            () => this.filter_data()
                          );
                        }}
                        style={{ width: "95%" }}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-lg-3 sort-by-filter-wrapper">
                      <label>Sort By</label>
                      <Select
                        defaultValue={this.state.sortBy}
                        style={{ width: "95%", marginRight: 8 }}
                        onChange={this.handleSortChange}
                        value={this.state.sortBy}
                        className="filter-element mb-3 filter-select-menu no-tag-select"
                        placeholder="Sort By"
                      >
                        <Option value="">Sort By</Option>
                        <Option value="LastContactedAsc">
                          Last Contacted Asc
                        </Option>
                        <Option value="LastContactedDesc">
                          Last Contacted Desc
                        </Option>
                        <Option value="LastActiveAsc">Last Session Asc</Option>
                        <Option value="LastActiveDesc">
                          Last Session Desc
                        </Option>
                      </Select>
                    </div>
                    <div className="col-lg-3 filter-by-status-input-wrapper">
                      <label>Filter By Status</label>
                      <Select
                        className="select-status filter-element mb-3 filter-select-menu no-tag-select"
                        mode="tags"
                        defaultValue={this.state.selectedStatus}
                        style={{ width: "95%", marginRight: 8 }}
                        onChange={this.filterStatus}
                        value={this.state.selectedStatus}
                        placeholder="Filter By Status"
                      >
                        {this.state.type == "active" &&
                          ACTIVE_STATUS_LIST.map((item, index) => {
                            return (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            );
                          })}
                        {this.state.type == "not_active" &&
                          NOT_ACTIVE_STATUS_LIST.map((item, index) => {
                            return (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            );
                          })}
                        {this.state.type == "all" &&
                          ALL_STATUS_LIST.map((item, index) => {
                            return (
                              <Option value={item} key={index}>
                                {item}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>
                    <div className="col-lg-4"></div>
                  </div>
                  <div className="row participant-activity-table">
                    <div className="col-lg-11" style={{ marginLeft: "auto" }}>
                      <Table
                        dataSource={dataSource}
                        loading={this.state.tableloader}
                        columns={this.state.activeColumns}
                        pagination={{ pageSize: this.state.pagination }}
                        scroll={{
                          x:
                            this.state.isSingleColumn === true
                              ? 0
                              : localStorage.getItem("PHIStatus") === "true"
                              ? 1900
                              : 2000,
                        }}
                        onChange={this.handleTableChange}
                        rowSelection={null}
                      />
                      <br />
                      {/* Start note section  */}
                      <RadcliffNote />
                      {/* End note section  */}
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default List;